import * as Constants from "./Constants";
import structuredClone from "@ungap/structured-clone";
import SkuEndpoints from "../lib/sku/SkuEndpoints";
import { BoxValidationResult } from "../lib/interfaces/ConveyorBox/IConveyorBox";
const { WorkstationTypes, CartType } = Constants;

export const ParseCartNumberFromScan = (toParse) => {
  let input = toParse;
  var hasPrefix = input.indexOf("V") >= 0;
  input = hasPrefix ? input.split("V")[1] : input;
  let cartNumber = input.split("N")[0];

  return parseInt(cartNumber);
};

export const ParseInputType = (toParse) => {
  if (/^V\d{2,5}N\d{2,3}|^V\d{2,5}|^\d{2,5}$/.test(toParse)) {
    return Constants.SCAN_INPUT_TYPE_CART;
  } else if (/^K\d{4,7}\d*$/.test(toParse)) {
    return Constants.SCAN_INPUT_TYPE_SKU;
  } else if (/^\d{8,14}$/.test(toParse)) {
    return Constants.SCAN_INPUT_TYPE_EAN;
  } else if (toParse.indexOf(String.fromCharCode(29)) > -1) {
    return Constants.SCAN_INPUT_TYPE_2D;
  } else if (/^U\d{4,7}\d*$/.test(toParse)) {
    return Constants.SCAN_INPUT_TYPE_UNDO_SKU;
  } else if (/^[F].{8}$/.test(toParse)) {
    return Constants.SCAN_INPUT_TYPE_FAKTURA;
  } else if (/^[X].{8}$/.test(toParse)) {
    return Constants.SCAN_INPUT_TYPE_BOXID;
  } else if (/^[B].{12}$/.test(toParse)) {
    return Constants.SCAN_INPUT_TYPE_BOXBARCODE;
  } else if (toParse.length > 17) {
    return Constants.SCAN_INPUT_TYPE_2D;
  } else {
    return Constants.SCAN_INPUT_TYPE_UNDEFINED;
  }
};

export const ValidateShelf = (toValidate) => {
  toValidate = "" + toValidate;
  toValidate = toValidate.toUpperCase();
  var startstWithH = toValidate[0] === "H";

  let ordinaryShelfRE = /^H[A-Z]{2}[0-9]{2}[A-Z][0-9]$/;
  let rxCartShelfRE = /^HP[A-Z]{1}[0-9]{4}$/;

  let validateFormat = ordinaryShelfRE.test(toValidate) || rxCartShelfRE.test(toValidate);

  var conditions = [
    {
      condition: startstWithH,
      errorMessage: "Plats måste starta med 'H'.",
    },
    {
      condition: validateFormat,
      errorMessage: "Felaktigt format på inmatad plats.",
    },
  ];
  return resolveConditions(conditions, toValidate);
};

const resolveConditions = (conditions, val) => {
  return new Promise((resolve, reject) => {
    if (checkConditions(conditions)) {
      resolve(val);
    } else {
      reject(failedConditions(conditions)[0].errorMessage);
    }
  });
};
const checkConditions = (conditions) => conditions.map((x) => x.condition).reduce((x, y) => x && y);
const failedConditions = (conditions) => conditions.filter((x) => !x.condition);

export const GSCharInputFix = () => {
  var input = document.getElementsByClassName("ScanInputField")[0];

  let _gsCharFix = (e, input) => {
    if (e.charCode === 29) {
      input.value += String.fromCharCode(e.which);
    }
  };
  if (input) {
    input.removeEventListener("keypress", (e) => {
      _gsCharFix(e, input);
    });
    input.addEventListener("keypress", (e) => {
      _gsCharFix(e, input);
    });
  }
};

// type är int, string, date etc
export const SortList = (list, property, desc, type) => {
  return list.sort((a, b) => {
    let value_a, value_b;

    switch (type) {
      case "int":
        value_a = a[property];
        value_b = b[property];
        break;
      case "string":
        value_a = a[property].toUpper();
        value_b = b[property].toUpper();
        break;
      default:
        return null;
    }

    let directionSwitch = desc ? -1 : 1;

    let result = (value_a < value_b ? -1 : value_a > value_b ? 1 : 0) * directionSwitch;
    return result;
  });
};

export const GetUpdatedBoxItems = (newItems, originalItems) => {
  var toAdd = [];
  var toDelete = [];
  newItems.forEach((nbi) => {
    var match = originalItems.find(
      (obi) => nbi.skuID === obi.skuID && nbi.shelfNumber === obi.shelfNumber
    );
    var partialmatch = originalItems.find((obi) => nbi.skuID === obi.skuID);
    if (match) {
      if (nbi.delete) {
        toDelete.push(match);
      } else if (partialmatch) {
        toDelete.push(match);
        nbi.verifiedQuantity = match.verifiedQuantity;
        toAdd.push(nbi);
      }
    } else {
      if (!nbi.delete) {
        if (partialmatch) {
          toAdd.push(nbi);
        }
      }
    }
  });
  var newList = originalItems.filter(
    (obi) =>
      !toDelete.filter((nbi) => nbi.skuID === obi.skuID && nbi.shelfNumber === obi.shelfNumber)
        .length
  );
  newList = newList.concat(toAdd);
  return newList;
};

export const Validation = {
  validatePositiveInteger(toValidate) {
    var isInteger = !!toValidate || !!Number(toValidate);
    var isPostive = toValidate > -1;
    return isInteger && isPostive;
  },
};

export const IsAutoPack = (wsType) => {
  // if(wsType === -1 || !wsType) return true;
  return [
    WorkstationTypes.AutoPackSmall,
    WorkstationTypes.AutoPackMedium,
    WorkstationTypes.AutoPackLarge,
    WorkstationTypes.AutoPackXLarge,
    WorkstationTypes.AutoPackMixedSmall,
    WorkstationTypes.AutoPackMixedMedium,
    WorkstationTypes.AutoPackWestMixedSmall,
    WorkstationTypes.AutoPackWestMixedMedium,
  ].includes(wsType);
};

export const GetAllSortboxItemsHandleUpcomingPickAutomation = (
  currentAllSortBoxItems,
  missingBoxItem,
  currentBoxItems,
  mergedItems,
  newBoxItems
) => {
  var newAllSortboxItems = currentAllSortBoxItems.filter(
    (x) =>
      !newBoxItems.some(
        (z) =>
          z.delete &&
          x.boxID === z.boxID &&
          z.skuID === x.skuID &&
          z.shelfNumber === x.shelfNumber &&
          z.isRxItem === x.isRxItem
      )
  );
  var newItems = mergedItems.filter(
    (x) =>
      !newAllSortboxItems.some(
        (z) =>
          x.boxID === z.boxID &&
          z.skuID === x.skuID &&
          z.shelfNumber === x.shelfNumber &&
          z.isRxItem === x.isRxItem
      )
  );
  var notVisibleUpcomingItems = mergedItems.filter(
    (x) =>
      newBoxItems.some(
        (z) =>
          !x.delete &&
          z.skuId === x.skuId &&
          x.shelfNumber === z.shelfNumber &&
          z.isRxItem === x.isRxItem
      ) &&
      !currentBoxItems.some(
        (z) => z.skuId === x.skuId && x.shelfNumber === z.shelfNumber && z.isRxItem === x.isRxItem
      ) &&
      newAllSortboxItems.some(
        (z) => z.skuId === x.skuId && x.shelfNumber === z.shelfNumber && z.isRxItem === x.isRxItem
      )
  );
  var oldItemsToRetain = notVisibleUpcomingItems.map((x) => structuredClone(x));
  notVisibleUpcomingItems.forEach((x) => {
    x.reservedQuantity = missingBoxItem.reservedQuantity;
    x.verifiedQuantity = missingBoxItem.verifiedQuantity;
  });
  oldItemsToRetain.forEach((x) => {
    x.shelfNumber = "AA01A1";
    x.reservedQuantity -= missingBoxItem.reservedQuantity;
  });
  newAllSortboxItems = newAllSortboxItems.concat(oldItemsToRetain);
  return newAllSortboxItems.concat(newItems);
};

export const getSkuIDFromInput = (input, scanInputType, boxItems, callback) => {
  var boxLookupEAN = (ean) => {
    let boxItem = boxItems.find((bi) => {
      return bi.eans.map((e) => e.trim()).indexOf(ean) > -1;
    });
    if (boxItem) return boxItem.skuID;
    return -1;
  };

  if (scanInputType === Constants.SCAN_INPUT_TYPE_EAN) {
    callback(boxLookupEAN(input));
  } else if (scanInputType === Constants.SCAN_INPUT_TYPE_SKU) {
    callback(parseInt(input.substring(1)));
  } else if (scanInputType === Constants.SCAN_INPUT_TYPE_2D) {
    SkuEndpoints.GetEANFrom2D(input).then((ean) => callback(boxLookupEAN(ean)));
  }
};

export const HandleArticleScanSkuPutaway = (
  input,
  scanInputType,
  boxItems,
  boxItemsUpdatedCallback,
  performSkuPutaway,
  addError,
  useMissingQuantity
) => {
  getSkuIDFromInput(input, scanInputType, boxItems, (skuID) => {
    const currentSkuID = skuID;
    let boxItemsFound = boxItems
      .filter(
        (x) =>
          x.skuID === currentSkuID &&
          x.verifiedQuantity < x.reservedQuantity - (useMissingQuantity ? x.missingQuantity : 0) &&
          x.reservedQuantity - (useMissingQuantity ? x.missingQuantity : 0) > 0
      )
      .sort((a, b) => a.verifiedQuantity - b.reservedQuantity);
    let boxItemsScanStarted = boxItems.filter(
      (x) =>
        x.skuID !== currentSkuID &&
        x.verifiedQuantity < x.reservedQuantity - (useMissingQuantity ? x.missingQuantity : 0) &&
        x.verifiedQuantity > 0 &&
        x.reservedQuantity - (useMissingQuantity ? x.missingQuantity : 0) > 0
    );
    if (boxItemsScanStarted.length > 0) {
      addError(
        "Scanna färdigt samtliga varor av samma produkt, SKU: " + boxItemsScanStarted[0].skuID
      );
      return;
    }
    if (boxItemsFound.length > 0) {
      let boxItem = boxItemsFound[0];
      if (
        boxItem.verifiedQuantity + 1 <
        boxItem.reservedQuantity - (useMissingQuantity ? boxItem.missingQuantity : 0)
      ) {
        boxItem.verifiedQuantity++;
        boxItemsUpdatedCallback(boxItems);
      } else {
        performSkuPutaway(boxItem, input);
      }
    } else {
      addError("Artikel hör inte till plocklistan.");
    }
  });
};

export const IsManualPack = (wsType) => {
  return [WorkstationTypes.Pack, WorkstationTypes.RXsingel, WorkstationTypes.Review].includes(
    wsType
  );
};

export const IsAcceptableWorkstationType = (wsType) => {
  return (
    IsAutoPack(wsType) ||
    IsManualPack(wsType) ||
    wsType === WorkstationTypes.Review ||
    wsType === WorkstationTypes.AutostoreAutomation
  );
};

export const getCartType = (fromReview) => {
  if (fromReview) {
    return CartType.FROM_REVIEW;
  } else {
    return CartType.NORMAL_CART;
  }
};

export const GetUrlParams = () => {
  var params = document.location.search
    .split("?")
    .map((x) => x.split("&"))
    .reduce((a, b) => a.concat(b))
    .map((x) => x.split("="))
    .filter((x) => x.length > 1)
    .map((x) => {
      var a = {};
      a[x[0].toLowerCase()] = [x[1]];
      return a;
    });

  return params.length
    ? params.reduce((a, b) => {
        var n = { ...a };
        var hasKey = (obj, key) => !!n[key] || n[key] === 0 || n[key] === "0";
        Object.keys(b).forEach((key) => {
          if (!hasKey(n, key)) {
            n[key] = b[key];
          } else {
            n[key] = [...n[key], ...b[key]];
          }
        });
        return n;
      })
    : {};
};
export const getParamValue = (key) => {
  var params = GetUrlParams();
  var paramVal = params[key];
  if (paramVal && paramVal.length && paramVal[0]) {
    return paramVal[0];
  }
  return -1;
};

export const isBoxItemMatch = (boxItem1, boxItem2) => {
  return (
    boxItem1.skuID === boxItem2.skuID &&
    boxItem1.shelfNumber === boxItem2.shelfNumber &&
    boxItem1.isRxItem === boxItem2.isRxItem
  );
};

export const getBranchID = () => {
  try {
    const params = GetUrlParams();
    const branchId = parseInt(params["branch"]);
    return branchId;
  } catch (error) {
    return 12;
  }
};

export const getServerRoutePrefix = () => {
  const branchId = getBranchID();

  let serverRoutePrefix = "/api";
  switch (branchId) {
    case 20:
      serverRoutePrefix += "/boxreview";
      break;
    default:
      serverRoutePrefix += "/aframereview/";
  }
  return serverRoutePrefix;
};

class EH {
  constructor() {
    this.errors = [];
    this.t = null;
    this.timeOutSetting = 5000;
  }
  addError(error, callback) {
    this.errors = this.errors.concat(error);
    this._handleCallback(callback);
  }
  _removeError() {
    return this.errors.shift();
  }
  _handleCallback(callback) {
    if (!this.t) {
      var nextError = this._removeError();
      callback(nextError.message || (typeof nextError === "string" ? nextError : "Okänt fel"));
      this.t = setTimeout(() => {
        this.t = null;
        if (this.errors.length) {
          this._handleCallback(callback);
        } else {
          callback("");
        }
      }, this.timeOutSetting);
    }
  }
}

export const ErrorHandler = new EH();

// "DECLARE-ONCE-USE-EVERYWHERE" VARIABLES BELOW
export const branchID = getBranchID();

export const currentServerRoutePrefix = getServerRoutePrefix();
